module.exports = __webpack_public_path__ + "media/pop_drip_up.fdb96e2e.wav";